export default __webpack_public_path__ + "static/media/placeholder_dummy2016-raumgestalter01-de.73259a82.png";